import { MapboxVectorLayer } from 'ol-mapbox-style';

export function createMapboxLayer(visible: boolean) {
  return new MapboxVectorLayer({
    styleUrl: 'mapbox://styles/melcarne/cm1gsje3x003h01pef5uhgih6',
    accessToken: 'pk.eyJ1IjoibWVsY2FybmUiLCJhIjoiY20weHZ1cm5sMGM4bzJqcXY2ZW12Z3FjcCJ9.HVobOBbzDba3vcy1ozQOjw',
    visible,
    properties: { name: 'base_mapbox' },
  });
} 